{
  "SEARCH": {
    "TABS": {
      "ALL": "所有结果",
      "CONTACTS": "联系人",
      "CONVERSATIONS": "会话",
      "MESSAGES": "消息",
      "ARTICLES": "文章"
    },
    "SECTION": {
      "CONTACTS": "联系人",
      "CONVERSATIONS": "会话",
      "MESSAGES": "消息",
      "ARTICLES": "文章"
    },
    "VIEW_MORE": "查看更多",
    "LOAD_MORE": "加载更多",
    "SEARCHING_DATA": "搜索中",
    "LOADING_DATA": "加载中",
    "EMPTY_STATE": "未找到与查询 '{query}' 相关的 {item}",
    "EMPTY_STATE_FULL": "未找到与查询 '{query}' 相关的结果",
    "PLACEHOLDER_KEYBINDING": "/聚焦搜索框",
    "INPUT_PLACEHOLDER": "输入 3 个或更多字符以进行搜索",
    "RECENT_SEARCHES": "最近搜索",
    "CLEAR_ALL": "清除全部",
    "MOST_RECENT": "最近的",
    "EMPTY_STATE_DEFAULT": "通过会话 Id、电子邮件、电话号码、消息等进行搜索以获得更好的搜索结果。 ",
    "BOT_LABEL": "机器人",
    "READ_MORE": "查看更多",
    "READ_LESS": "阅读较低",
    "WROTE": "写道：",
    "FROM": "来自",
    "EMAIL": "Email",
    "EMAIL_SUBJECT": "主题",
    "PRIVATE": "私人笔记",
    "TRANSCRIPT": "文本",
    "CREATED_AT": "创建于 {time}",
    "UPDATED_AT": "更新于{time}",
    "SORT_BY": {
      "RELEVANCE": "相关性"
    },
    "DATE_RANGE": {
      "LAST_7_DAYS": "最近7天",
      "LAST_30_DAYS": "最近30天",
      "LAST_60_DAYS": "最近60天",
      "LAST_90_DAYS": "最近90天",
      "CUSTOM_RANGE": "自定义范围：",
      "CREATED_BETWEEN": "创建时间之间",
      "AND": "和",
      "APPLY": "应用",
      "BEFORE_DATE": "在{date}之前",
      "AFTER_DATE": "在{date}之后",
      "TIME_RANGE": "按时间筛选",
      "CLEAR_FILTER": "清除筛选条件"
    },
    "FILTERS": {
      "FILTER_MESSAGE": "筛选消息：",
      "FROM": "发件人",
      "IN": "收件箱",
      "AGENTS": "客服",
      "CONTACTS": "联系人",
      "INBOXES": "收件箱",
      "NO_AGENTS": "未找到客服代表",
      "NO_CONTACTS": "先搜索以查看结果",
      "NO_INBOXES": "未找到收件箱"
    }
  }
}
